export const STANDARD_EVENT_TYPE = 'Abbott-Organized Programs'
export const DIRECT_SPONSORSHIP_EVENT_TYPE = 'Direct HCPs Activity/Sponsorship'
export const EDUCATIONAL_GRANT_EVENT_TYPE = 'Educational Grant'
export const COMMERCIAL_SPONSORSHIP_EVENT_TYPE = 'Commercial Sponsorship'
